import React from "react";
import PropTypes from "prop-types";
import { RTEWrapper, ContentWrapper } from "BaseComponents/Wrappers";
import MapBlocksToComponents from "Helpers/BlockHelper";
import styled from "styled-components";
import { Video, VideoContainer } from "Components/Video";

let VideoPage = ({
	Heading,
	Preamble,
	Text,
	VideoLink,
	VideoType,

	ElementArea,
}) => {
	const ElementAreaWrapper = styled.div`
		background-color: ${({ theme }) => theme.colors.lightgrey};
	`;

	return (
		<>
			<ContentWrapper>
				{VideoLink && (
					<VideoContainer margin="15px 0 20px 0">
						<Video
							VideoLink={VideoLink}
							Heading={Heading}
							VideoType={VideoType}
						></Video>
					</VideoContainer>
				)}
				{Text && (
					<RTEWrapper
						dangerouslySetInnerHTML={{
							__html: Text,
						}}
					></RTEWrapper>
				)}
			</ContentWrapper>

			<ElementAreaWrapper>
				{ElementArea.length > 0 && MapBlocksToComponents(ElementArea)}
			</ElementAreaWrapper>
		</>
	);
};

VideoPage.propTypes = {
	Heading: PropTypes.string,
	Text: propTypes.string,
};

export default VideoPage;
